"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterLinksGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _box = _interopRequireDefault(require("@waglabs/box"));

var _flex = _interopRequireDefault(require("@waglabs/flex"));

var _text = _interopRequireDefault(require("@waglabs/text"));

var _FooterLink = require("./FooterLink");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var FooterLinksGroup = function FooterLinksGroup(props) {
  var data = props.data,
      title = props.title,
      rest = _objectWithoutProperties(props, ["data", "title"]);

  var links = data.links;
  return _react["default"].createElement(_box["default"], rest, _react["default"].createElement(_text["default"], {
    color: "#01BE8F",
    fontSize: ['1rem', '1rem', '1.125rem'],
    lineHeight: ['18px', '18px', '22px'],
    mb: "8px"
  }, title), _react["default"].createElement(_flex["default"], {
    flexDirection: "column"
  }, links.map(function (_ref) {
    var url = _ref.url,
        label = _ref.label;
    return _react["default"].createElement(_FooterLink.FooterLink, {
      key: label,
      href: url
    }, label);
  })));
};

exports.FooterLinksGroup = FooterLinksGroup;